import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { handleApiRequestSuccessData, handleRequestError } from '@jove-frontend/uikit';
import qs from 'qs';
import { api } from '../index';
export var apiCreateBroker = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.post("/brokers", payload);

          case 3:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function apiCreateBroker(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiUploadBrokerFile = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var params, res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            params = {
              broker_doc_enum: payload === null || payload === void 0 ? void 0 : payload.broker_doc_enum
            };
            _context2.next = 4;
            return api.post("/brokers/".concat(payload === null || payload === void 0 ? void 0 : payload.brokerId, "/broker_doc_file?").concat(qs.stringify(params)), payload === null || payload === void 0 ? void 0 : payload.formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });

          case 4:
            res = _context2.sent;
            handleApiRequestSuccessData(res);
            return _context2.abrupt("return", [res.data]);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0));

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function apiUploadBrokerFile(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiDeleteBrokerFile = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api["delete"]("/brokers/".concat(payload === null || payload === void 0 ? void 0 : payload.brokerId, "/broker_doc_file?").concat(qs.stringify(payload)));

          case 3:
            res = _context3.sent;
            handleApiRequestSuccessData(res);
            return _context3.abrupt("return", [res.data]);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function apiDeleteBrokerFile(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiUpdateBrokerInitialInfo = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.patch("/brokers/children/".concat(payload === null || payload === void 0 ? void 0 : payload.brokerId, "/init-general-settings"), payload);

          case 3:
            res = _context4.sent;
            handleApiRequestSuccessData(res);
            return _context4.abrupt("return", [res.data]);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0));

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));

  return function apiUpdateBrokerInitialInfo(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiResendBrokerMemberInvitationEmail = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.get("/partner_invitations/".concat(payload === null || payload === void 0 ? void 0 : payload.memberId, "/resend-email"));

          case 3:
            res = _context5.sent;
            handleApiRequestSuccessData(res);
            return _context5.abrupt("return", [res.data]);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0));

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 8]]);
  }));

  return function apiResendBrokerMemberInvitationEmail(_x5) {
    return _ref5.apply(this, arguments);
  };
}();